import { Component, OnInit, HostBinding, Input } from '@angular/core';

export type ButtonType = 'icon' | 'primary' | 'secondary' | 'submit' | 'reset' | 'danger';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'button, [button]',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {

  @Input() type: ButtonType = 'secondary';
  @Input() icon?: string;
  @Input() label?: string;

  @HostBinding('class.is-icon') public isIconButton = false;
  @HostBinding('class.is-primary') public isPrimary = false;
  @HostBinding('class.is-secondary') public isSecondary = false;
  @HostBinding('class.is-danger') public isDanger = false;

  public ngOnInit() {
    switch (this.type) {
      case 'primary':
        this.isPrimary = true;
        break;
      case 'submit':
        this.isPrimary = true;
        break;
      case 'secondary':
        this.isSecondary = true;
        break;
      case 'reset':
        this.isSecondary = true;
        break;
      case 'danger':
        this.isDanger = true;
        break;
      case 'icon':
        this.isIconButton = true;
        break;
      default:
        this.isSecondary = true;
    }
  }
}
